import React from 'react';
import CertificateDetailTemplate from './CertificateDetailTemplate';
import infosysImage from '../../../assets/images/Infosys Springboard Image.png';

const certificates = [
  {
    title: 'Software Engineerning',
    issuedBy: 'Infosys Springboard',
    date: '22 february 2025',
    image: infosysImage,
    link: 'https://drive.google.com/file/d/1mR8KeFLTkl4_YS3tyyMLy1IjnkXy4TuY/view?usp=drive_link'
  },
  {
    title: 'Artificial Intelligence & Machine Learning',
    issuedBy: 'Infosys Springboard',
    date: '1 March 2025',
    image: infosysImage,
    link: 'https://drive.google.com/file/d/1g0pP5p7-JQX7HvEfChF15KQC8ETIRCe5/view?usp=drive_link'
  },
  {
    title: 'Azure AI Fundamentals Artificial Intelligence Concepts',
    issuedBy: 'Infosys Springboard',
    date: '4 March 2025',
    image: infosysImage,
    link: 'https://drive.google.com/file/d/1WTKvMUab9--JX7WBPtPxQcJCcaTCW2-n/view?usp=drive_link'
  }
];

const InfosysSpringboardCertificates = () => {
  return (
    <CertificateDetailTemplate
      provider="Infosys Springboard"
      certificates={certificates}
    />
  );
};

export default InfosysSpringboardCertificates;
